import bridge from '@libs/bridge';
import { FetchConfig, ApiResponse, ApiResponseV2 } from '@typings/request';
import axios from 'axios';

export const agent = axios.create({
  baseURL: '/',
  timeout: 10000,
  // withCredentials: true,
});

export function guardResponse<T extends ApiResponse<unknown>>(res: T) {
  if (Number(res.ret) === 0) {
    return res;
  }
  return Promise.reject(res);
}

export function guardResponseV2<T extends ApiResponseV2<unknown>>(res: T) {
  if (Number(res.status) === 0) {
    return res;
  }
  return Promise.reject(res);
}

export function fetchRaw<T>(config: FetchConfig): Promise<T> {
  return bridge.app
    .fetch(config as Required<FetchConfig>)
    .then(res => {
      if (res.code !== 1) {
        return Promise.reject(res);
      }
      let response;
      try {
        response = JSON.parse(res.data.response);
      } catch (error) {
        // eslint-disable-next-line prefer-promise-reject-errors
        return Promise.reject(error);
      }
      return response;
    })
    .catch(err => {
      console.log(err);
    });
}

export function fetch<T extends ApiResponse<unknown>>(config: FetchConfig) {
  return fetchRaw<T>(config).then(guardResponse);
}

/**
 * 后台新封装接口，适用/feed/v1下的接口
 * @param config
 * @returns
 */
export function fetchV2<T extends ApiResponseV2<unknown>>(config: FetchConfig) {
  return fetchRaw<T>(config).then(guardResponseV2);
}
